import React from 'react';
import { useLoggedOutAthletePageContext } from '../../../../state/LoggedOutAthletePageContext';
import { getProfileVisibility } from '../../../../helpers/getProfileVisibility';
import JoinStravaCTA from '../../../JoinStravaCTA';

import emptyActivitiesImg from './assets/img-empty.png';
import emptyActivitiesImg2x from './assets/img-empty@2x.png';
import styles from './EmptyActivities.module.scss';

const EmptyActivities = () => {
  const { t, track, state } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete } = athleteData;

  const handleTrack = () => {
    track({
      action: 'click',
      element: 'start_signup',
      properties: {
        profile_visibility: getProfileVisibility(athlete),
        signup_copy: 'no_activities_follow_on_strava'
      }
    });
  };

  return (
    <div className={styles.emptyActivities}>
      <img
        src={emptyActivitiesImg}
        alt=""
        srcSet={`${emptyActivitiesImg} 1x, ${emptyActivitiesImg2x} 2x`}
      />

      <p className={styles.empty}>
        <a href={athlete.followUrl} onClick={handleTrack}>
          {t('activity_empty_state', { athlete_name: athlete.name })}
        </a>
      </p>
      <JoinStravaCTA
        className={styles.joinStravaCTA}
        heading={t('mobile_cta')}
        linkConfig={{
          href: '/register',
          text: t('get_strava_cta')
        }}
        trackConfig={{
          element: 'start_signup',
          signupCopy: 'get_strava_1'
        }}
      />
    </div>
  );
};

export default EmptyActivities;
